<template>
    <component :is="template">
        <template v-if="ready">
            <v-card v-if="ready && product" v-intersect="{ handler: onIntersect, options: { threshold: [0, 1.0] } }" elevation="0" class="contents-area">
                <div class="mb-3">
                    <span v-for="(category, index) in categories" :key="category._id">
                        <span style="cursor: pointer" :class="index === categories.length - 1 ? 'font-weight-bold' : ''" @click="$router.push(`/shop/${getCategoryPath(categories[0].code, category, index)}`)">
                            {{ category.name }}
                        </span>
                        <span v-if="index !== categories.length - 1"> > </span>
                    </span>
                    <!-- <span @click="$router.push('/shop/bestseller?type=main&_category=61ee1344162e94a123def3ea&page=1')">도서 ></span>
                <span :class="`${tertiaryCategory ? '' : 'font-weight-bold'}`">{{` ${secondaryCategory} `}}</span>
                <span v-if="tertiaryCategory"> > </span>
                <span v-if="tertiaryCategory" class="font-weight-bold">{{` ${tertiaryCategory}`}}</span> -->
                </div>
                <div class="contents-area__inner">
                    <v-row>
                        <!-- 상품 이미지 -->
                        <v-col cols="12" md="5">
                            <v-carousel height="auto" hide-delimiters show-arrows-on-hover :show-arrows="1 < product?.images?.length">
                                <v-carousel-item v-for="(image, index) in product?.images || []" :key="index">
                                    <v-img :src="image" width="100%" max-width="480" min-height="442" max-height="584" contain />
                                </v-carousel-item>
                            </v-carousel>
                        </v-col>

                        <!-- 상품정보 -->
                        <v-col cols="12" md="7">
                            <div class="pl-md-10">
                                <!-- 제품명 -->
                                <template>
                                    <div class="tit-wrap mb-20px mb-md-30px">
                                        <div class="tit tit--sm primary--text">
                                            <p v-html="product.name" />
                                        </div>
                                    </div>
                                </template>

                                <v-divider />

                                <!-- 판매가 -->
                                <div class="py-10px py-md-16px">
                                    <template>
                                        <product-info-field label="판매가" class="font-weight-medium">
                                            <v-row no-gutters align="center">
                                                <v-col cols="auto">
                                                    <span v-if="product?.costPrice && product?.costPrice != product?.salePrice" class="font-size-14 line-height-1 text-decoration-line-through grey--text mr-8px">{{ product?.costPrice?.format?.() }}원</span>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <div class="d-inline-flex align-center font-size-18 font-size-md-20 line-height-1">
                                                        <b>{{ product?.salePrice?.format?.() }}</b
                                                        ><span class="font-size-16 ml-2px">원</span>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </product-info-field>
                                    </template>
                                </div>

                                <v-divider />

                                <div class="py-10px py-md-16px">
                                    <template v-if="product.writer">
                                        <product-info-field label="저자">{{ product.writer }}</product-info-field>
                                    </template>

                                    <template v-if="product.publisher">
                                        <product-info-field label="출판사">{{ product.publisher }}</product-info-field>
                                    </template>

                                    <!-- <template>
                                    <product-info-field label="적립금"><b>{{ parseInt(0).format() }}</b> 원</product-info-field>
                                </template> -->

                                    <template v-if="!product.ebookProducts.length">
                                        <product-info-field label="배송비">
                                            <span v-if="product.shippingCode === 'later'"><b>착불배송</b></span>
                                            <span v-if="product.shippingCode === 'self'"
                                                ><b>{{ parseInt(product.shippingPrice).format() }}</b
                                                >원</span
                                            >
                                            <span v-if="product.shippingCode === 'free'"><b>배송비 무료</b></span>
                                            <span v-if="product.shippingCode === 'order'"
                                                ><b>{{ `${setting.shippingPrice.lt.format()}원 (${setting.saleAmount.format()}원 이상은 무료배송)` }}</b></span
                                            >
                                        </product-info-field>
                                    </template>

                                    <template v-if="!product.ebookProducts.length">
                                        <product-info-field label="배송일정">
                                            <div class="grey--text text--darken-2">
                                                <div>* 당일 13시까지 주문건에 한하여, 당일 출고됩니다.</div>
                                                <div>택배사 일정에 따라 2~3일 소요될 수 있습니다. (도서산간 제외)</div>
                                            </div>
                                        </product-info-field>
                                    </template>

                                    <template>
                                        <product-info-field v-for="(item, index) in product.info" :label="item.name" :key="index">
                                            <span v-if="item"
                                                ><b>{{ item.value }}</b></span
                                            >
                                        </product-info-field>
                                    </template>

                                    <template v-if="product.ebookProducts.length">
                                        <product-info-field label="지원기기">
                                            <div class="grey--text text--darken-2">
                                                <div>iOS | Android | PC | Mac</div>
                                                <div>iOS 13.4 버전부터 이용 가능</div>
                                            </div>
                                        </product-info-field>
                                    </template>

                                    <template v-if="product.ebookProducts.length">
                                        <product-info-field label="안내사항">
                                            <div class="grey--text text--darken-2">
                                                <div>이 상품은 구매 후 웹에서 바로 이용 가능한 상품으로 배송되지 않습니다.</div>
                                                <div>전자책 열람시 데이터가 소모되어 데이터 요금이 발생할 수 있습니다. Wifi를 이용해주세요.</div>
                                                <div>구매한 eBook 상품은 마이페이지 > eBook 열람 에서 확인 가능합니다.</div>
                                            </div>
                                        </product-info-field>
                                    </template>

                                    <template v-if="product.ebookProducts.length">
                                        <product-info-field label="환불규정">
                                            <div class="grey--text text--darken-2">
                                                <div>최초 열람 이후 환불이 불가합니다. 미 열람시 7일 이내 100% 환불 가능하며 7일 이후 90%로 환불 가능합니다.</div>
                                            </div>
                                        </product-info-field>
                                    </template>
                                </div>

                                <!-- PC 수량 레이아웃 : 옵션상품 사용할때-->
                                <template v-if="!$vuetify.breakpoint.mobile && product.optionalProducts?.length">
                                    <v-divider />
                                    <div class="py-10px py-md-16px">
                                        <optional-products v-model="carts" :product="product" />
                                    </div>
                                </template>

                                <!-- PC 수량 레이아웃 : 재고가 없을때-->
                                <template v-if="!product.stock">
                                    <v-divider />
                                    <div class="py-10px py-md-16px">
                                        <product-info-field label="수량" class="mt-4 font-weight-bold">품절</product-info-field>
                                    </div>
                                </template>

                                <v-divider />

                                <!-- PC 수량 레이아웃 : 재고가 있을때 -->
                                <template v-if="!$vuetify.breakpoint.mobile && carts.length">
                                    <div v-if="!product.ebookProducts.length" class="py-10px py-md-16px">
                                        <cart-list v-model="carts" />
                                    </div>

                                    <v-divider />
                                    <div class="py-10px py-md-16px">
                                        <v-row align="center" class="row--small font-size-14">
                                            <v-col cols="3" md="2"> 총 합계 </v-col>
                                            <v-col cols="9" md="10">
                                                <div class="d-inline-flex align-center font-size-18 font-size-md-24">
                                                    <b class="primary--text">{{ parseInt(totalAmount).format() }}</b
                                                    ><span class="font-size-16 ml-2px">원</span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <v-divider class="border-2" />

                                    <div class="py-10px py-md-16px">
                                        <v-row align="center" class="row--x-small">
                                            <v-col>
                                                <v-btn block tile x-large outlined :disabled="!!product.ebookProducts.length" color="grey" @click="gift"> <v-icon class="mr-10px grey--text text--darken-3">mdi-gift-outline</v-icon><span class="grey--text text--darken-3">선물하기</span> </v-btn>
                                            </v-col>
                                            <v-col>
                                                <v-btn block tile x-large :disabled="!!product.ebookProducts.length" color="secondary" @click="addToCart"><v-icon class="mr-10px">mdi-cart-outline</v-icon>장바구니</v-btn>
                                            </v-col>
                                            <v-col>
                                                <template v-if="ebook">
                                                    <v-btn block tile x-large color="primary" @click="open(ebook)"><v-icon class="mr-10px">mdi-shopping-outline</v-icon>열람하기</v-btn>
                                                </template>
                                                <template v-else>
                                                    <v-btn block tile x-large color="primary" @click="order"><v-icon class="mr-10px">mdi-shopping-outline</v-icon>바로구매</v-btn>
                                                </template>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <!--네이버 구매하기-->
                                    <!-- <v-divider class="border-2" />

                                <div class="py-10px py-md-16px">
                                    <v-row align="center" class="row--x-small">
                                        <v-spacer />
                                        <naver-pay :carts="carts" @update="carts = []"/>
                                    </v-row>
                                </div> -->
                                </template>
                            </div>
                        </v-col>
                    </v-row>

                    <v-divider class="d-none d-lg-block" />

                    <!-- 이전상품·다음상품 레이아웃 -->
                    <div class="pt-10px pt-md-16px">
                        <v-row class="row--x-small">
                            <v-col cols="auto">
                                <v-btn small outlined color="grey" :to="{ path: `/shop/${path}/${prevProduct?._id}`, query: $route.query }" :disabled="!prevProduct">
                                    <span class="d-flex align-center grey--text text--darken-3"><v-icon small class="mr-4px mr-md-10px">mdi-chevron-left</v-icon>이전상품보기</span>
                                </v-btn>
                            </v-col>
                            <v-spacer />
                            <v-col cols="auto">
                                <v-btn small outlined color="grey" :to="{ path: `/shop/${path}/${nextProduct?._id}`, query: $route.query }" :disabled="!nextProduct">
                                    <span class="d-flex align-center grey--text text--darken-3">다음상품보기<v-icon small class="ml-4px ml-md-10px">mdi-chevron-right</v-icon></span>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-card>

            <v-divider />

            <!-- 인터섹팅 레이아웃 : 스크롤 아래로 내렸을때, 화면 상단에 도킹 -->
            <v-app-bar v-if="!isIntersecting" height="54" fixed color="white" elevation="2">
                <v-tabs v-model="intersectingIndex" show-arrows grow>
                    <v-tab><v-btn x-large text block :ripple="false" href="#product-content">상품정보</v-btn></v-tab>
                    <v-tab><v-btn x-large text block :ripple="false" href="#product-review">기대평/리뷰</v-btn></v-tab>
                    <v-tab><v-btn x-large text block :ripple="false" href="#product-inquiry">상품문의</v-btn></v-tab>
                    <v-tab><v-btn x-large text block :ripple="false" href="#product-delivery">교환/환불/배송</v-btn></v-tab>
                </v-tabs>
            </v-app-bar>

            <!-- 상품 컨텐츠 -->
            <div class="overflow-hidden">
                <v-tabs v-model="intersectingIndex" show-arrows grow>
                    <v-tab><v-btn x-large text block :ripple="false" href="#product-content">상품정보</v-btn></v-tab>
                    <v-tab><v-btn x-large text block :ripple="false" href="#product-review">기대평/리뷰</v-btn></v-tab>
                    <v-tab><v-btn x-large text block :ripple="false" href="#product-inquiry">상품문의</v-btn></v-tab>
                    <v-tab><v-btn x-large text block :ripple="false" href="#product-delivery">교환/환불/배송</v-btn></v-tab>
                </v-tabs>
                <v-divider />

                <div class="contents-area">
                    <div class="contents-area__inner">
                        <div id="product-content" class="mt-n60px pt-60px"></div>
                        <v-responsive v-intersect="{ handler: onDetails, options: { threshold: [0, 1.0] } }" class="mb-10px">
                            <div>
                                <v-img src="/images/products/gift-guide.jpg" />
                                <p v-html="product?.content"></p>
                            </div>
                        </v-responsive>

                        <div id="product-review" class="pt-60px"></div>
                        <v-responsive v-intersect="{ handler: onExpectReview, options: { threshold: [0, 1.0] } }" class="mb-10px">
                            <div class="tit-wrap mb-10px mb-md-20px">
                                <h3 class="tit tit--xs">기대평</h3>
                            </div>
                            <expectation-list :product="product" />

                            <div class="pt-60px"></div>
                            <div class="tit-wrap mb-10px mb-md-20px">
                                <h3 class="tit tit--xs">리뷰</h3>
                            </div>
                            <review-list :product="product" />
                        </v-responsive>

                        <div id="product-inquiry" class="pt-60px"></div>
                        <v-responsive v-intersect="{ handler: onInquiry, options: { threshold: [0, 1.0] } }" class="mb-10px">
                            <div class="tit-wrap mb-10px mb-md-20px">
                                <h3 class="tit tit--xs">상품문의</h3>
                            </div>
                            <inquiry-list :product="product" />
                        </v-responsive>

                        <div id="product-delivery" class="pt-60px"></div>
                        <v-responsive v-intersect="{ handler: onExchange, options: { threshold: [0, 1.0] } }">
                            <div class="tit-wrap mb-10px mb-md-20px">
                                <h3 class="tit tit--xs">교환/반품/품절안내</h3>
                            </div>
                            <div class="table-style table-style--default">
                                <div class="table-style__row">
                                    <div class="table-style__th">반품/교환방법</div>
                                    <div class="table-style__td">
                                        <div class="page-text">
                                            <p>
                                                <router-link to="/mypage/shop/purchases" class="primery--text">마이페이지 &gt; 주문배송조회 &gt; 반품/교환신청 , <br />고객센터 &gt; 1:1문의를 통해 반품 &gt; 교환신청 또는 고객센터 (1800-9510)</router-link>
                                            </p>
                                            <p>※ 오픈마켓, 해외배송주문, 기프트 주문시 <router-link to="/center/questions">[1:1문의]</router-link> 또는 고객센터 (1800-9510)</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-style__row">
                                    <div class="table-style__th">반품/교환가능 기간</div>
                                    <div class="table-style__td">
                                        <div class="page-text">
                                            <p>변심반품의 경우 수령 후 7일 이내, 상품의 결함 및 계약내용과 다를 경우 문제점 발견 후 30일 이내</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-style__row">
                                    <div class="table-style__th">반품/교환비용</div>
                                    <div class="table-style__td">
                                        <div class="page-text">
                                            <p>변심 혹은 구매착오로 인한 반품/교환은 반송료 고객 부담</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-style__row">
                                    <div class="table-style__th">반품/교환 불가 사유</div>
                                    <div class="table-style__td">
                                        <div class="page-text">
                                            <p>소비자의 책임 있는 사유로 상품 등이 손실 또는 훼손된 경우 (단지 확인을 위한 포장 훼손은 제외)</p>
                                            <p>소비자의 사용, 포장 개봉에 의해 상품 등의 가치가 현저히 감소한 경우<br />예) 화장품, 식품, 가전제품(악세서리 포함) 등</p>
                                            <p>복제가 가능한 상품 등의 포장을 훼손한 경우<br />예) 음반/DVD/비디오, 소프트웨어, 만화책, 잡지, 영상 화보집</p>
                                            <p>소비자의 요청에 따라 개별적으로 주문 제작되는 상품의 경우 ((1)해외주문도서)<br />(1)해외주문도서 : 이용자의 요청에 의한 개인주문상품으로 단순변심 및 착오로 인한 취소/교환/반품 시 ‘해외주문 반품/취소 수수료’고객 부담 (해외주문 반품/취소 수수료 : ①양서-판매정가의 12%, ②일서-판매정가의 7%를 적용)</p>
                                            <p>디지털 컨텐츠인 eBook, 오디오북 등을 1회 이상 다운로드를 받았을 경우</p>
                                            <p>시간의 경과에 의해 재판매가 곤란한 정도로 가치가 현저히 감소한 경우</p>
                                            <p>전자상거래 등에서의 소비자보호에 관한 법률이 정하는 소비자 청약철회 제한 내용에 해당되는 경우</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-style__row">
                                    <div class="table-style__th">상품 품절</div>
                                    <div class="table-style__td">
                                        <div class="page-text">
                                            <p>공급사(출판사) 재고 사정에 의해 품절/지연될 수 있으며, 품절 시 관련 사항에 대해서는 이메일과 문자로 안내드리겠습니다.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-style__row">
                                    <div class="table-style__th">소비자 피해보상 환불지연에 따른 배상</div>
                                    <div class="table-style__td">
                                        <div class="page-text">
                                            <p>상품의 불량에 의한 교환, A/S, 환불, 품질보증 및 피해보상 등에 관한 사항은 소비자분쟁해결 기준 (공정거래위원회 고시)에 준하여 처리됨</p>
                                            <p>대금 환불 및 환불지연에 따른 배상금 지급 조건, 절차 등은 전자상거래 등에서의 소비자 보호에 관한 법률에 따라 처리함</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-style__row">
                                    <div class="table-style__th">청약 철회 방침</div>
                                    <div class="table-style__td">
                                        <div class="page-text">
                                            <p>상품 발송 후 환불 신청 시 반품확인 여부를 확인 후 3~5영업일 이내 결제금액을 환불해 드립니다.</p>
                                            <p>신용카드로 결제하신 경우 신용카드 승인을 취소하여 결제대금이 청구되지 않게 합니다.<br />(단, 신용카드 결제일자에 맞추어 대금이 청구 될 수 있으며, 이경우 익월 신용카드 대금 청구 시 카드사에서 환급 처리 됩니다.)​</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-responsive>
                    </div>
                </div>
            </div>
            <login-dialog ref="loginDialog" />
        </template>

        <!-- S: Mobile 하단 네비게이션 -->
        <template v-if="$vuetify.breakpoint.mobile && ready" slot="fab" slot-scope="{ showScroll, scrollTo }">
            <v-app-bar app bottom height="auto" color="transparent" elevation="1">
                <v-responsive class="overflow-visible">
                    <!-- Top 버튼 -->
                    <v-btn v-show="showScroll" fab absolute top right large tile color="primary" class="mt-n40px" @click="scrollTo(0, 0)">
                        <div class="pa-12px">
                            <v-icon size="20" class="my-n4px">mdi-chevron-up</v-icon>
                            <div class="font-size-14 font-weight-medium mb-6px">TOP</div>
                        </div>
                    </v-btn>

                    <v-card elevation="0">
                        <v-divider />
                        <div>
                            <v-btn @click="expand = !expand" :ripple="false" block color="grey lighten-4" height="28" slot="extension" active-class="no-active">
                                <v-icon v-show="!expand" color="grey">mdi-chevron-up</v-icon>
                                <v-icon v-show="expand" color="grey">mdi-chevron-down</v-icon>
                            </v-btn>
                        </div>

                        <v-expand-transition>
                            <v-responsive v-show="expand" elevation="0">
                                <v-divider />
                                <div class="pa-12px py-md-14px">
                                    <!-- PC 수량 레이아웃 : 옵션상품 사용할때-->
                                    <template v-if="product.optionalProducts?.length">
                                        <optional-products v-model="carts" :product="product" />
                                    </template>

                                    <template v-if="carts.length && !product.ebookProducts.length">
                                        <cart-list v-model="carts" />
                                    </template>

                                    <div class="mt-10px">
                                        <v-row align="center" class="row--small font-size-14">
                                            <v-col cols="3" md="2"> 총 합계 </v-col>
                                            <v-col cols="9" md="10" class="text-right">
                                                <div class="d-inline-flex align-center font-size-20">
                                                    <b class="primary--text">{{ parseInt(totalAmount).format() }}</b
                                                    ><span class="font-size-14 ml-2px">원</span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>
                                <v-divider />
                            </v-responsive>
                        </v-expand-transition>

                        <div class="pa-12px py-md-14px">
                            <v-row class="row--x-small">
                                <v-col cols="auto">
                                    <v-btn @click="gift" :disabled="!!product.ebookProducts.length" icon tile outlined color="grey" width="42" height="42"><v-icon class="grey--text text--darken-3">mdi-gift-outline</v-icon></v-btn>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn @click="addToCart" :disabled="!!product.ebookProducts.length" fab tile color="secondary" width="42" height="42"><v-icon>mdi-cart-outline</v-icon></v-btn>
                                </v-col>
                                <v-col>
                                    <template v-if="ebook">
                                        <v-btn @click="open(ebook)" x-large block color="primary">열람하기</v-btn>
                                    </template>
                                    <template v-else>
                                        <v-btn @click="order" x-large block color="primary">구매하기</v-btn>
                                    </template>
                                </v-col>
                            </v-row>
                            <!-- <v-row class="row--x-small">
                            <v-spacer/>
                            <v-col>
                                <naver-pay :carts="carts" @update="carts = []" type="MA"/>
                            </v-col>
                        </v-row> -->
                        </div>
                    </v-card>
                </v-responsive>
            </v-app-bar>
        </template>
        <!-- E: Mobile 하단 네비게이션 -->
    </component>
</template>
<script>
import api from "@/api";
import { mdiChevronUp, mdiChevronDown, mdiChevronLeft, mdiChevronRight, mdiPlusCircleMultipleOutline, mdiCartOutline, mdiGiftOutline, mdiShoppingOutline } from "@mdi/js";

import LoginDialog from "@/components/client/login/login-dialog.vue";
import ProductInfoField from "@/components/client/shop/product/product-info-field.vue";
import CartList from "@/components/client/shop/product/cart-list.vue";
import OptionalProducts from "@/components/client/shop/product/optional-products.vue";
import ReviewList from "@/components/client/shop/product/review-list.vue";
import InquiryList from "@/components/client/shop/product/inquiry-list.vue";
import ExpectationList from "@/components/client/shop/product/expectation-list.vue";
import NaverPay from "@/components/plugins/naver/naver-pay.vue";

export default {
    components: {
        LoginDialog,
        ProductInfoField,
        CartList,
        OptionalProducts,
        ReviewList,
        InquiryList,
        ExpectationList,
        NaverPay,
    },
    data() {
        return {
            // 아이콘
            mdiCartOutline,
            mdiGiftOutline,
            mdiChevronUp,
            mdiChevronDown,
            mdiChevronLeft,
            mdiChevronRight,
            mdiShoppingOutline,
            mdiPlusCircleMultipleOutline,

            ready: false,
            expand: false, // 모바일 하단 네비게이션 확장·축소

            product: null,
            prevProduct: null,
            nextProduct: null,

            carts: [], // 수량

            me: null,
            ebook: null,

            // 인터렉션 & 인터섹팅 데이터
            intersectingIndex: 0,
            intersecting: {
                isDetails: false,
                isExpectReview: false,
                isInquiry: false,
                isExchange: false,
            },

            offsetTop: 0,
            showAppBar: false,
            isIntersecting: false,
            isScroll: false,

            setting: null,

            path: null,

            purchase: null,
            tertiaryCategory: null,

            categories: [],
        };
    },
    async mounted() {
        await this.init();
        this.path = this.$route.path.split("/")[2];
    },
    methods: {
        async init() {
            this.carts = [];
            this.categories = [];

            let { product, prev, next } = await api.v1.shop.products.get({
                _id: this.$attrs._product || this.$attrs.code,
                params: { _category: this.$route.query._category },
            });
            this.product = product;
            this.prevProduct = prev;
            this.nextProduct = next;

            let { setting } = await api.v1.shop.setting.get();
            this.setting = setting;

            let { category } = await api.v1.shop.categories.get({ _id: product._categories[0] });

            this.categories.push(category);
            if (category._parents.length > 0) {
                for (let i = 0; i < category._parents.length; i++) {
                    let { category: parent } = await api.v1.shop.categories.get({ _id: category._parents[i] });
                    this.categories.push(parent);
                }
                this.categories.sort((a, b) => a.depth - b.depth);
            }
            if (category.depth === 3) this.tertiaryCategory = category.name;

            if (this.accessToken) {
                let { me } = await api.v1.me.profile.get();
                this.me = me;
            }

            if (product.ebookProducts.length) {
                this.carts.push({ product: product.ebookProducts[0], quantity: 1 });

                // ebook 상품 구매데이터
                if (this.me) {
                    let { ebook, purchase } = await api.v1.me.shop.ebooks.get(product.ebookProducts[0]);
                    this.purchase = purchase;
                    this.ebook = ebook;
                }
            } else if (product.type == "main" && product.stock && !product.optionalProducts.length && !product.ebookProducts.length) {
                this.carts.push({ product, quantity: 1 });
            }

            this.$store.dispatch("recent", { _id: product._id, thumb: product.thumb });

            this.ready = true;
        },

        // 선물·구매·장바구니 클릭했을때, 검증
        validate() {
            try {
                if (this.carts.find((cart) => cart.quantity <= 0)) throw new Error("구매수량을 입력해주세요.");

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },

        async login() {
            return new Promise((resolve, reject) => {
                if (this.logon) resolve();
                else {
                    this.$refs.loginDialog.$off();
                    this.$refs.loginDialog.$on("login", (_) => resolve());
                    this.$refs.loginDialog.$on("cancel", (_) => reject());
                    this.$refs.loginDialog.open();
                }
            });
        },
        async addToCart() {
            if (this.validate() && await this.$confirm("장바구니에 담으시겠습니까?")) {
                this.login().then(async (_) => {
                    for (let cart of this.carts) {
                        await api.v1.me.shop.carts.post(cart);
                    }
                    if (await this.$confirm("장바구니에 담았습니다.\n바로 확인하시겠습니까?")) {
                        this.$router.push("/mypage/shop/carts");
                    }
                });
            }
        },
        async gift() {
            if (this.validate()) {
                this.login().then(async (_) => {
                    this.$store.dispatch("pickup", { carts: this.carts });
                    this.$router.push(`/shop/gift-order`);
                });
            }
        },
        async order() {
            if (this.validate()) {
                this.login().then(async (_) => {
                    this.$store.dispatch("pickup", { carts: this.carts });
                    this.$router.push(`/shop/order`);
                });
            }
        },
        complete(order) {
            this.$refs.completeDialog.order = order;
            this.$refs.completeDialog.open();
        },

        getCategoryPath(code, category, index) {
            if (code === "book") {
                return `${this.categories[1].code}?_category=${category.depth === 1 ? this.categories[1]._id : category._id}`;
            }
            if (code === "ebook") {
                return "ebook";
            }
            if (code === "shopping") {
                return `products?_category=${category._id}`;
            } else return `/`;
        },

        // ebook 열람하기
        async open(ebook) {
            if (this.purchase.ebookStatus === "미열람") {
                if (await this.$confirm("eBook을 열람하시겠습니까? \n열람시 취소가 불가능합니다.")) {
                    let {
                        ebook: { ebookValue },
                    } = await api.v1.me.shop.ebooks.get(ebook);
                    this.goWebviwer(ebookValue, this._user);
                }
            } else {
                let {
                    ebook: { ebookValue },
                } = await api.v1.me.shop.ebooks.get(ebook);
                this.goWebviwer(ebookValue, this._user);
            }
        },

        async goWebviwer(ebookValue, uid) {
            // window.location.href = ebookValue + "?uid=" + uid
            let form = document.createElement("form");

            let obj = document.createElement("input");

            obj.setAttribute("name", "uid");

            obj.setAttribute("value", uid);

            form.appendChild(obj);

            form.setAttribute("method", "post");

            form.setAttribute("action", ebookValue);

            form.setAttribute("target", "_blank");

            document.body.appendChild(form);

            form.submit();
        },

        ///////////////////////////////////////////////////////////////////////////////////
        // 인터렉션
        ///////////////////////////////////////////////////////////////////////////////////

        scrollTop() {
            window.scrollTo(0, 0);
        },

        onIntersect(entries, observer) {
            if (this.isIntersecting != entries[0].isIntersecting) this.isIntersecting = entries[0].isIntersecting;
        },
        onDetails(entries, observer) {
            if (this.intersecting.isDetails != entries[0].isIntersecting) this.intersecting.isDetails = entries[0].isIntersecting;
        },
        onExpectReview(entries, observer) {
            if (this.intersecting.isExpectReview != entries[0].isIntersecting) this.intersecting.isExpectReview = entries[0].isIntersecting;
        },
        onInquiry(entries, observer) {
            if (this.intersecting.isInquiry != entries[0].isIntersecting) this.intersecting.isInquiry = entries[0].isIntersecting;
        },
        onExchange(entries, observer) {
            if (this.intersecting.isExchange != entries[0].isIntersecting) this.intersecting.isExchange = entries[0].isIntersecting;
        },
        // onScroll (entries, observer) {
        //     // More information about these options
        //     // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        //     this.isScroll = entries[0].isIntersecting;
        // },
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.shop}`);
        },
        logon() {
            return !!this.$store.state.accessToken;
        },
        logoff() {
            return !this.$store.state.accessToken;
        },
        accessToken() {
            return this.$store.state.accessToken;
        },

        saleAmount() {
            return this.carts.reduce((saleAmount, cart) => {
                return (saleAmount += cart.product.salePrice * cart.quantity);
            }, 0);
        },
        shippingAmount() {
            return this.product.shippingPrice;
        },
        totalAmount() {
            if (this.product.shippingCode === "self") return this.saleAmount + this.shippingAmount;
            if (this.product.shippingCode === "order") {
                if (this.saleAmount >= this.setting.saleAmount) {
                    return this.saleAmount;
                } else {
                    return this.saleAmount + this.setting.shippingPrice.lt;
                }
            }
            if (this.product.shippingCode === "free") return this.saleAmount;
            return this.saleAmount;
        },
        payload() {
            return this.$store.state.payload;
        },
        _user() {
            return this.$store.state.payload._user;
        },
        secondaryCategory() {
            const categoryMap = {
                bestseller: "베스트셀러",
                children: "유아동",
                independent: "독립출판물",
                discount: "할인도서",
                ebook: "ebook",
            };
            return categoryMap[this.path];
        },
    },
    watch: {
        quantity() {
            this.saleAmount = this.quantity * this.product.salePrice;
        },
        async accessToken() {
            if (this.accessToken) {
                let { me } = await api.v1.me.profile.get();
                this.me = me;
            } else this.me = null;
        },

        carts: {
            handler() {
                for (let cart of this.carts) {
                    let quantity = parseInt(String(cart.quantity).replace(/[^0-9]/g, "") || 1);
                    let { stock } = cart.product;
                    if (stock && stock < quantity) {
                        alert("재고가 부족합니다");
                        cart.quantity = stock;
                    } else if (quantity < 1) cart.quantity = 1;
                    else cart.quantity = quantity;
                }
            },
            deep: true,
        },

        // $route: {
        //     deep: true,
        //     handler(){
        //         this.ready = false;
        //         this.init();
        //     }
        // },

        "$route.params._product"() {
            this.ready = false;
            this.init();
        },

        intersecting: {
            deep: true,
            handler() {
                if (this.intersecting.isDetails) this.intersectingIndex = 0;
                else if (this.intersecting.isExpectReview) this.intersectingIndex = 1;
                else if (this.intersecting.isInquiry) this.intersectingIndex = 2;
                else if (this.intersecting.isExchange) this.intersectingIndex = 3;
            },
        },
    },
};
</script>

<style scoped>
#contents .v-app-bar {
    height: auto !important;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .contents-area__inner {
        background-color: transparent;
    }
}
@media (min-width: 1200px) {
}
</style>